import { render, staticRenderFns } from "./fee-invoice.vue?vue&type=template&id=1075f1fb"
import script from "./fee-invoice.vue?vue&type=script&lang=js"
export * from "./fee-invoice.vue?vue&type=script&lang=js"
import style0 from "./fee-invoice.vue?vue&type=style&index=0&id=1075f1fb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports